<script>
import options from './StafetRoundCounterAccordion.options'
export default options
</script>

<template>
  <div class="kb-stafet-round-counter-accordion__wrapper">
    <h2 class="kb-stafet-round-counter-accordion__title">
      {{ getLabel('accordionTitle') }}
    </h2>

    <template v-for="(participant, index) in participantData" :key="index">
      <div class="kb-stafet-round-counter-accordion">
        <h3 class="kb-stafet-round-counter-accordion__participant">
          <svg
            viewBox="0 0 705 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
          </svg>
          <button
            :id="`acc-participant${participant.id}`"
            :aria-controls="`acc-content${participant.id}`"
            aria-expanded="false"
            v-on:click="toggleAccordion"
          >
            <p class="kb-stafet-round-counter-accordion__participant-name">
              {{ participant.participantName }}
              <span class="kb-stafet-round-counter-accordion__participant-role">
                {{ participant.participantRole }}</span
              >
            </p>
            <div
              class="kb-stafet-round-counter-accordion__participant-chevron kb-ui-icon kb-ui-icon--ui-chevron-down"
            ></div>
          </button>
        </h3>
        <div
          class="kb-stafet-round-counter-accordion__content"
          :id="`acc-content${participant.id}`"
          role="region"
          :aria-labelledby="`acc-participant${participant.id}`"
        >
        <template v-for="rute in participant.ruter">
          <StafetRoundCounter
            :rute="rute"
            :deltagerId="participant.id"
            :maxRegistrationCount="maxRegistrationCount"
          ></StafetRoundCounter>
        </template>
        </div>
      </div>
    </template>
  </div>
</template>
